import { requestBuilder } from '../../../http/RequestBuilder';
import type { UpdateReason, UpdateStatus } from '../../types/Card';

interface UpdateCreditCardBody {
    cardStatus: UpdateStatus;
    reason?: UpdateReason;
}

export const useUpdateCreditCard = requestBuilder.mutation<
    { success: true },
    UpdateCreditCardBody,
    { cardId: string }
>({
    endpoint: ({ cardId }) => `/api/card/${cardId}`,
    method: 'PATCH',
});

export default useUpdateCreditCard;
